<template>
	<div class="stars">
		<div class="table">
			<div class="tr">
				<div class="th">Type</div>
				<div class="th">Stars</div>
			</div>
			<div class="tr" v-for="(rate, key) in ratings" :key="`${rate}-${key}`">
				<div class="td">{{rate.type}}</div>
				<div class="td">
					<div class="stepperButton" @click="decreaseRatings(key)">-</div>
					<div class="rating">{{(rate.starRating > 0 ? '+' : '')}}{{rate.starRating}}</div>
					<div class="stepperButton" @click="increaseRatings(key)">+</div>
				</div>
			</div>
		</div>
		<div class="confirmRatings" :class="diableRatings" @click="confirmRatings()">
        <span  v-tooltip="buttonText">{{starRatingsUpdated}}</span></div>
	</div>
</template>

<script>
export default {
    name: 'starsTable',
    props: {
        types: {
            type: Array,
        },
    },
    data () {
        return {
            ratings: [],
            updated: false,
        };
    },
    created () {
        this.ratings = this.types.map(i => ({ type: i, starRating: 0 }));
    },
    computed: {
        diableRatings () {
            return this.ratings === 0 ? 'disabled' : '';
        },
        starRatingsUpdated () {
            return this.updated ? 'Updated' : 'Assign stars';
        },
        buttonText () {
            return this.ratings === 0 ? 'Use the plus and minus buttons to adjust the stars first' : 'Assign stars to this test';
        },
    },
    methods: {
        increaseRatings (key) {
            this.ratings[key].starRating < 9 ? ++this.ratings[key].starRating : '';
            this.$emit('rating', this.ratings);
        },
        decreaseRatings (key) {
            this.ratings[key].starRating > -9 ? --this.ratings[key].starRating : '';
            this.$emit('rating', this.ratings);
        },
        confirmRatings () {
            if (this.starRating !== 0) {
                this.$emit('currentRating', this.ratings);
                this.updated = !this.updated;
                setTimeout(() => {
                    this.updated = false;
                    this.starRating = 0;
                }, 2000);
                // this.$store.commit('updateBulkRatings', this.starRating);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/all.scss';
.stars {
	margin-bottom: 20px;
    .table {
        background: white!important;
        display: table;
        font-size:12px;
        width: 100%;
        .tr {
            display: table-row;
        }
        .th {
            background:$bodyBg;
            display: table-cell;
            font-weight: 500;
            padding: 5px;
        }
        .td {
            background: white;
            border-bottom: 1px solid $bodyBg;
            display: table-cell;
            padding: 5px;
        }
    }
	.stepperButton {
		background: $LCPWatermelon;
		border-radius: 6px;
		color: white;
		cursor: pointer;
		display: inline-block;
		margin: 0px;
		padding: 10px 20px;
		position: relative;
		text-align: center;
		user-select: none;
		vertical-align: middle;
	}
	.rating {
		display: inline-block;
		text-align: center;
		width: 20px;
	}
	.confirmRatings {
		background:$LCPWatermelon;
		border-radius: 6px;
		color: white;
		cursor: pointer;
		display: block;
		margin-top: 10px;
		padding: 10px 20px;
		position: relative;
		text-align: center;
		user-select: none;
		width: 145px;
		.icon {
			color: #FFF;
			font-size: 16px;
			line-height: unset;
			position: unset;
			text-align: unset;
			vertical-align: middle;
			width: 26px;
		}
		&.disabled {
			background-color: lightgray;
			cursor: not-allowed;
		}
		&.updated {
			background-color: $LCPAquamarine;
		}
	}
}
</style>
